// src/api-keys.ts
var RustyApiKeys = class {
  constructor({ client }) {
    this.client = client;
  }
  async createApiKey(request, accessToken) {
    const result = await this.client.post("/a/api-keys", request, {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async listApiKeys(accessToken) {
    const result = await this.client.get("/a/api-keys", {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async updateApiKey(id, request, accessToken) {
    const result = await this.client.put(`/a/api-keys/${id}`, request, {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async deleteApiKey(id, accessToken) {
    const result = await this.client.delete(`/a/api-keys/${id}`, {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async getApiKeyUsage(id, accessToken) {
    const result = await this.client.get(`/a/api-keys/${id}/usage`, {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
};

// src/auth.ts
import axios from "axios";

// src/types/api.ts
function makeUrl(url, params) {
  if (params) {
    const entries = Object.entries(params).filter(([, value]) => value !== void 0).map(([key, value]) => [key, String(value)]);
    const search = new URLSearchParams(entries).toString();
    return search ? `${url}?${search}` : url;
  }
  return url;
}

// src/types/login.ts
var LOGIN_METHOD = /* @__PURE__ */ ((LOGIN_METHOD2) => {
  LOGIN_METHOD2["MANUAL"] = "MANUAL";
  LOGIN_METHOD2["NOSTR"] = "NOSTR";
  LOGIN_METHOD2["PRIVATE_KEY"] = "PRIVATE_KEY";
  LOGIN_METHOD2["EMAIL_MAGIC_LINK"] = "EMAIL_MAGIC_LINK";
  LOGIN_METHOD2["GOOGLE"] = "GOOGLE";
  LOGIN_METHOD2["GITHUB"] = "GITHUB";
  LOGIN_METHOD2["MICROSOFT"] = "MICROSOFT";
  LOGIN_METHOD2["OIDC"] = "OIDC";
  return LOGIN_METHOD2;
})(LOGIN_METHOD || {});
var LOGIN_METHOD_NOSTR = [
  "NOSTR" /* NOSTR */,
  "PRIVATE_KEY" /* PRIVATE_KEY */,
  "MANUAL" /* MANUAL */
];
var LOGIN_METHOD_EMAIL_MAGIC_LINK = ["EMAIL_MAGIC_LINK" /* EMAIL_MAGIC_LINK */];
var LOGIN_METHOD_GOOGLE = ["GOOGLE" /* GOOGLE */];
var LOGIN_METHOD_GITHUB = ["GITHUB" /* GITHUB */];
var LOGIN_METHOD_MICROSOFT = ["MICROSOFT" /* MICROSOFT */];
var LOGIN_METHOD_OIDC = ["OIDC" /* OIDC */];
var OFFICIAL_LOGIN_METHODS = [
  "NOSTR" /* NOSTR */,
  "EMAIL_MAGIC_LINK" /* EMAIL_MAGIC_LINK */,
  "GOOGLE" /* GOOGLE */,
  "GITHUB" /* GITHUB */,
  "MICROSOFT" /* MICROSOFT */,
  "OIDC" /* OIDC */
];
var loginMethodFromType = (type) => {
  switch (type) {
    case "NOSTR":
      return "NOSTR" /* NOSTR */;
    case "EMAIL_MAGIC_LINK":
      return "EMAIL_MAGIC_LINK" /* EMAIL_MAGIC_LINK */;
    case "GOOGLE":
      return "GOOGLE" /* GOOGLE */;
    case "GITHUB":
      return "GITHUB" /* GITHUB */;
    case "MICROSOFT":
      return "MICROSOFT" /* MICROSOFT */;
    case "OIDC":
      return "OIDC" /* OIDC */;
    default:
      return void 0;
  }
};
var loginMethodFromTypeOrThrow = (type) => {
  const method = loginMethodFromType(type);
  if (!method) {
    throw new Error(`Unsupported login method type: ${type}`);
  }
  return method;
};
var isOfficialLoginMethod = (type) => {
  const loginMethod = loginMethodFromType(type);
  return loginMethod ? OFFICIAL_LOGIN_METHODS.includes(loginMethod) : false;
};

// src/types/rusty-common/axios-errors.ts
function hasFieldValidationError(error) {
  return Boolean(error?.isAxiosError && error?.response?.data?.error === "validation_error");
}
function axiosFieldValidationErrorToFormErrors(validationError) {
  const responseData = validationError.response?.data;
  if (responseData.error !== "validation_error") {
    return {};
  }
  const formErrors = {};
  responseData.errors.forEach((fieldError) => {
    if (fieldError.field && fieldError.message) {
      formErrors[fieldError.field] = fieldError.message;
    }
  });
  return formErrors;
}

// src/types/rusty-common/generated.ts
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["BTC"] = "btc";
  Currency2["EUR"] = "eur";
  Currency2["USDT"] = "usdt";
  Currency2["DAI"] = "dai";
  Currency2["USD"] = "usd";
  Currency2["AED"] = "aed";
  Currency2["ARS"] = "ars";
  Currency2["AUD"] = "aud";
  Currency2["BDT"] = "bdt";
  Currency2["BGN"] = "bgn";
  Currency2["BOB"] = "bob";
  Currency2["BRL"] = "brl";
  Currency2["CAD"] = "cad";
  Currency2["CHF"] = "chf";
  Currency2["CLP"] = "clp";
  Currency2["CNY"] = "cny";
  Currency2["COP"] = "cop";
  Currency2["CRC"] = "crc";
  Currency2["CZK"] = "czk";
  Currency2["DKK"] = "dkk";
  Currency2["DOP"] = "dop";
  Currency2["EGP"] = "egp";
  Currency2["FJD"] = "fjd";
  Currency2["GBP"] = "gbp";
  Currency2["HKD"] = "hkd";
  Currency2["HRK"] = "hrk";
  Currency2["HUF"] = "huf";
  Currency2["IDR"] = "idr";
  Currency2["ILS"] = "ils";
  Currency2["INR"] = "inr";
  Currency2["JPY"] = "jpy";
  Currency2["KES"] = "kes";
  Currency2["KRW"] = "krw";
  Currency2["LKR"] = "lkr";
  Currency2["MAD"] = "mad";
  Currency2["MXN"] = "mxn";
  Currency2["MYR"] = "myr";
  Currency2["NGN"] = "ngn";
  Currency2["NOK"] = "nok";
  Currency2["NZD"] = "nzd";
  Currency2["PEN"] = "pen";
  Currency2["PHP"] = "php";
  Currency2["PKR"] = "pkr";
  Currency2["PLN"] = "pln";
  Currency2["QAR"] = "qar";
  Currency2["RON"] = "ron";
  Currency2["RUB"] = "rub";
  Currency2["SAR"] = "sar";
  Currency2["SEK"] = "sek";
  Currency2["SGD"] = "sgd";
  Currency2["THB"] = "thb";
  Currency2["TRY"] = "try";
  Currency2["TWD"] = "twd";
  Currency2["UAH"] = "uah";
  Currency2["VND"] = "vnd";
  Currency2["ZAR"] = "zar";
  return Currency2;
})(Currency || {});
var DepositStatus = /* @__PURE__ */ ((DepositStatus2) => {
  DepositStatus2["PENDING"] = "PENDING";
  DepositStatus2["DONE"] = "DONE";
  DepositStatus2["ERROR"] = "ERROR";
  return DepositStatus2;
})(DepositStatus || {});
var DepositProvider = /* @__PURE__ */ ((DepositProvider2) => {
  DepositProvider2["STRIPE"] = "STRIPE";
  DepositProvider2["COINBASE"] = "COINBASE";
  return DepositProvider2;
})(DepositProvider || {});
var TwoFactorMethodType = /* @__PURE__ */ ((TwoFactorMethodType2) => {
  TwoFactorMethodType2["Totp"] = "totp";
  TwoFactorMethodType2["Webauthn"] = "webauthn";
  return TwoFactorMethodType2;
})(TwoFactorMethodType || {});
var SubscriptionStatus = /* @__PURE__ */ ((SubscriptionStatus2) => {
  SubscriptionStatus2["ACTIVE"] = "ACTIVE";
  SubscriptionStatus2["GracePeriod"] = "GracePeriod";
  SubscriptionStatus2["EXPIRED"] = "EXPIRED";
  SubscriptionStatus2["CANCELLED"] = "CANCELLED";
  return SubscriptionStatus2;
})(SubscriptionStatus || {});

// src/utils/billing.ts
var FIAT_DIVISOR = 1e5;
var SATS_PER_BTC = 1e8;
var CRYPTO_META = {
  ["btc" /* BTC */]: { divisor: SATS_PER_BTC, minDigits: 2, maxDigits: 8, prefix: "\u20BF" },
  ["usdt" /* USDT */]: { divisor: FIAT_DIVISOR, minDigits: 2, maxDigits: 6, suffix: "USDT" },
  ["dai" /* DAI */]: { divisor: FIAT_DIVISOR, minDigits: 2, maxDigits: 6, suffix: "DAI" }
};
function getCurrencyMeta(currency) {
  const crypto = CRYPTO_META[currency];
  if (crypto) return crypto;
  return {
    divisor: FIAT_DIVISOR,
    minDigits: 2,
    maxDigits: 2,
    isoCode: currency.toUpperCase()
  };
}
function balanceNextHigher(bal) {
  if (bal[1] === 0) return 0;
  return bal[1] / getCurrencyMeta(bal[0]).divisor;
}
function formatCurrency(bal, options = {}) {
  const [currency, amount] = bal;
  const meta = getCurrencyMeta(currency);
  const value = amount / meta.divisor;
  const minDigits = options.minFractionDigits ?? meta.minDigits;
  const maxDigits = Math.max(options.maxFractionDigits ?? meta.maxDigits, minDigits);
  const locale = options.locale ?? "en-US";
  if (meta.isoCode) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: meta.isoCode,
      minimumFractionDigits: minDigits,
      maximumFractionDigits: maxDigits
    }).format(value);
  }
  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits
  }).format(value);
  if (meta.prefix) return `${meta.prefix}${formatted}`;
  if (meta.suffix) return `${formatted} ${meta.suffix}`;
  return formatted;
}

// src/utils/deep-merge.ts
function deepMerge(base, ...sources) {
  const out = {};
  for (const source of [base, ...sources]) {
    if (!isPlainObject(source)) continue;
    mergeInto(out, source);
  }
  return out;
}
function mergeInto(target, source) {
  for (const key of Object.keys(source)) {
    const incoming = source[key];
    const existing = target[key];
    if (isPlainObject(existing) && isPlainObject(incoming)) {
      const next = { ...existing };
      mergeInto(next, incoming);
      target[key] = next;
    } else {
      target[key] = incoming;
    }
  }
}
function isPlainObject(value) {
  if (value === null || typeof value !== "object") return false;
  if (Array.isArray(value)) return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

// src/utils/error-title.ts
var getErrorTitle = (error) => {
  if (error.response) {
    const status = error.response.status;
    switch (status) {
      case 400:
        return "Bad Request";
      case 401:
        return "Authentication Required";
      case 403:
        return "Access Denied";
      case 404:
        return "Not Found";
      case 409:
        return "Conflict";
      case 422:
        return "Validation Error";
      case 500:
        return "Server Error";
      default:
        return `Error ${status}`;
    }
  } else if (error.request) {
    return "Network Error";
  }
  return "API Error";
};

// src/constants.ts
var LOCAL_STORAGE_KEY = "rusty.session";

// src/utils/localstore.ts
function hasFutureExpiry(expiresAt, threshold) {
  const now = Math.round(Date.now() / 1e3);
  return expiresAt > now + threshold;
}
function getLsLoginSession(storageKey = LOCAL_STORAGE_KEY) {
  console.debug("getLoginSession");
  const sessionJson = localStorage.getItem(`${storageKey}.data`);
  if (sessionJson) {
    return JSON.parse(sessionJson);
  }
  return null;
}
function getLsSession(storageKey = LOCAL_STORAGE_KEY) {
  console.debug("getLsSession");
  const sessionJson = localStorage.getItem(`${storageKey}.data`);
  if (sessionJson) {
    const session = JSON.parse(sessionJson);
    if (session.accessTokenExpiresAt && typeof session.accessTokenExpiresAt === "string") {
      session.accessTokenExpiresAt = parseInt(session.accessTokenExpiresAt, 10);
    }
    if (!session.accessTokenExpiresAt) {
      console.warn("Session data is incomplete (no accessTokenExpiresAt); clearing local storage");
      clearLsSession(storageKey);
      return null;
    }
    if (!session.isLoggedIn) {
      console.warn("Session is not logged in, clearing local storage");
      clearLsSession(storageKey);
      return null;
    }
    return session;
  }
  return null;
}
function setLsSession(session, storageKey = LOCAL_STORAGE_KEY) {
  console.debug("setLsSession", session);
  localStorage.setItem(`${storageKey}.data`, JSON.stringify(session));
}
function clearLsSession(storageKey = LOCAL_STORAGE_KEY) {
  console.debug("clearLsSession");
  localStorage.removeItem(`${storageKey}.data`);
}

// src/utils/make-auth-headers.ts
function makeAuthHeaders(token) {
  return {
    Authorization: `Bearer ${token}`
  };
}

// src/utils/nostr.ts
import { decodeNostrPrivateKeyString } from "@nostr-ts/common";
function decodeNostrPrivateKey(privateKey) {
  if (privateKey.startsWith("nsec")) {
    return decodeNostrPrivateKeyString(`nostr:${privateKey}`);
  } else if (privateKey.startsWith("nostr:")) {
    return decodeNostrPrivateKeyString(privateKey);
  } else {
    return privateKey;
  }
}
function decodeNostrPublicKey(publicKey) {
  if (publicKey.startsWith("npub")) {
    return publicKey;
  } else if (publicKey.startsWith("nostr:")) {
    return publicKey.slice(6);
  } else {
    return publicKey;
  }
}

// src/utils/rss-parser.ts
import { XMLParser } from "fast-xml-parser";
function parseRSS(xml) {
  const parser = new XMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: "@_",
    parseAttributeValue: true
  });
  const result = parser.parse(xml);
  if (result.feed?.entry) {
    result.feed.entry = result.feed.entry.map((entry) => ({
      ...entry,
      category: Array.isArray(entry.category) ? entry.category.map((cat) => cat["@_term"]) : [entry.category["@_term"]],
      link: entry.link?.["@_href"] || "",
      summary: typeof entry.summary === "object" && entry.summary["#text"] ? entry.summary["#text"] : entry.summary,
      content: typeof entry.content === "object" && entry.content["#text"] ? entry.content["#text"] : entry.content,
      title: typeof entry.title === "object" && entry.title["#text"] ? entry.title["#text"] : entry.title
    }));
  }
  return result;
}

// src/auth.ts
var isSafeRedirectTarget = (candidate) => {
  let parsed;
  try {
    parsed = new URL(candidate);
  } catch {
    return false;
  }
  return parsed.protocol === "https:" || parsed.protocol === "http:";
};
var isSafeSameOriginTarget = (candidate) => {
  try {
    const parsed = new URL(candidate, window.location.origin);
    if (parsed.protocol !== "https:" && parsed.protocol !== "http:") return false;
    return parsed.origin === window.location.origin;
  } catch {
    return false;
  }
};
var rfc3339ToUnixSeconds = (value) => {
  const ms = Date.parse(value);
  if (Number.isNaN(ms)) {
    throw new Error(`Invalid RFC 3339 datetime from backend: ${value}`);
  }
  return Math.floor(ms / 1e3);
};
var sessionExpiriesFromLoginSuccess = (ls) => {
  if (!ls.access_token_expires_at) {
    throw new Error("BrowserLoginSuccess.access_token_expires_at missing \u2014 backend is out of date");
  }
  return {
    accessTokenExpiresAt: rfc3339ToUnixSeconds(ls.access_token_expires_at)
  };
};
var RustyAuth = class {
  constructor({
    baseUrl,
    timeout,
    useLocalStore,
    localStorageKey,
    onSessionChange
  }) {
    this.useLocalStore = false;
    this.baseUrl = baseUrl || "https://api.checkoutbay.com/v1";
    this.timeout = timeout || 5e3;
    this.useLocalStore = useLocalStore || false;
    if (localStorageKey) {
      this.localStorageKey = localStorageKey;
    } else {
      throw new Error("localStorageKey is required");
    }
    this.onSessionChange = onSessionChange;
    this.client = axios.create({
      baseURL: this.baseUrl,
      timeout: this.timeout,
      headers: {
        "Content-Type": "application/json"
      }
    });
    this.session = {
      isLoggedIn: false
    };
    console.info(`[api] => baseUrl: ${this.baseUrl}`);
    if (this.useLocalStore) {
      console.info("[api] => Using local storage for session management");
      const storedSession = getLsSession(this.localStorageKey);
      if (storedSession) {
        this.session = storedSession;
        console.debug("[api] => Loaded session from local storage", this.session);
      } else {
        console.debug("[api] => No session found in local storage");
      }
    }
  }
  getSession() {
    return this.session;
  }
  setSession(session) {
    this.session = session;
    if (this.useLocalStore) {
      setLsSession(session, this.localStorageKey);
    }
    try {
      this.onSessionChange?.(session);
    } catch (e) {
      console.warn("AUTH: onSessionChange callback threw; continuing", e);
    }
  }
  clearSession() {
    if (this.useLocalStore) {
      clearLsSession(this.localStorageKey);
    }
    this.session = { isLoggedIn: false };
    try {
      this.onSessionChange?.(null);
    } catch (e) {
      console.warn("AUTH: onSessionChange callback threw; continuing", e);
    }
  }
  hasValidAccessToken(threshold = 30) {
    if (!this.session.isLoggedIn) {
      console.warn("AUTH: Session is not logged in");
      return false;
    }
    if (this.session.accessTokenExpiresAt === void 0) {
      console.warn("AUTH: Access token expiration time is not defined");
      return false;
    }
    if (!hasFutureExpiry(this.session.accessTokenExpiresAt, threshold)) {
      console.warn(
        `AUTH: Access token is not valid, expires at ${this.session.accessTokenExpiresAt}`
      );
      return false;
    }
    return true;
  }
  getUserId() {
    if (!this.session.userId) {
      throw new Error("No user id");
    }
    return this.session.userId;
  }
  getAccessToken() {
    if (!this.hasValidAccessToken()) {
      throw new Error("No access token");
    }
    return this.session.accessToken;
  }
  async login(loginRequest) {
    const referralCode = localStorage.getItem("pendingReferralCode");
    if (referralCode) {
      loginRequest.content.referral_code = referralCode;
    }
    switch (loginRequest.type) {
      case "NOSTR" /* NOSTR */:
        this.setSession({
          isLoggedIn: false,
          publicKey: loginRequest.content.public_key,
          method: "NOSTR" /* NOSTR */
        });
        break;
      case "EMAIL_MAGIC_LINK" /* EMAIL_MAGIC_LINK */:
        this.setSession({
          isLoggedIn: false,
          method: "EMAIL_MAGIC_LINK" /* EMAIL_MAGIC_LINK */
        });
        break;
      case "GOOGLE" /* GOOGLE */:
        this.setSession({
          isLoggedIn: false,
          method: "GOOGLE" /* GOOGLE */
        });
        break;
      case "GITHUB" /* GITHUB */:
        this.setSession({
          isLoggedIn: false,
          method: "GITHUB" /* GITHUB */
        });
        break;
      case "OIDC" /* OIDC */:
        this.setSession({
          isLoggedIn: false,
          method: "OIDC" /* OIDC */
        });
        break;
      default:
        throw new Error(`Unsupported login method: ${loginRequest.type}`);
    }
    const { data } = await this.client.post("/login", loginRequest);
    return data;
  }
  /**
   * Track 9 split-token: the challenge endpoint funnels success through the
   * auth-code flow. On success we transparently exchange the code so the
   * caller sees a populated session, mirroring the pre-Track-9 contract.
   * Callers that need to fork on the raw envelope (2FA prompt) can inspect
   * the returned status.
   */
  async loginChallenge(props) {
    const { data } = await this.client.post("/login/challenge", props);
    if (data.status === "success") {
      const method = loginMethodFromTypeOrThrow(props.type);
      let publicKey;
      if (method === "NOSTR" /* NOSTR */ && this.useLocalStore) {
        const savedSession = getLsLoginSession(this.localStorageKey);
        if (savedSession?.publicKey) {
          publicKey = savedSession.publicKey;
        } else {
          console.warn(
            `No public key found in local storage for NOSTR login (${JSON.stringify(savedSession)})`
          );
        }
      }
      const browser = await this.exchangeAuthCode(data.code, method);
      this.applyLoginSuccess(browser, method, publicKey);
    }
    return data;
  }
  async verify2FA(request) {
    const { data } = await this.client.post("/login/2fa", request);
    if (data.status !== "success") {
      throw new Error(`AUTH: unexpected /login/2fa response status: ${data.status}`);
    }
    const pendingSession = this.getSession();
    const method = pendingSession.method;
    if (!method) {
      throw new Error(
        "AUTH: 2FA verify with no pending method on session \u2014 login flow not initialised"
      );
    }
    const browser = await this.exchangeAuthCode(data.code, method);
    const publicKey = method === "NOSTR" /* NOSTR */ ? pendingSession.publicKey : void 0;
    this.applyLoginSuccess(browser, method, publicKey);
    return browser;
  }
  /**
   * Exchange an auth code for a `BrowserLoginSuccess`. Uses
   * `withCredentials: true` so the browser accepts the `Set-Cookie`
   * carrying the opaque session token.
   */
  async exchangeAuthCode(code, _method) {
    const { data } = await this.client.post(
      "/login/exchange",
      { code },
      { withCredentials: true }
    );
    return data;
  }
  /**
   * Apply a `BrowserLoginSuccess` to the in-memory + persisted session,
   * preserving identity claims that aren't part of the response (e.g. the
   * NOSTR public key, which is client-supplied at /login time).
   */
  applyLoginSuccess(data, method, publicKey) {
    const newSession = {
      isLoggedIn: true,
      userId: data.user_id,
      accessToken: data.access_token,
      email: data.email,
      displayName: data.display_name,
      ...publicKey !== void 0 ? { publicKey } : {},
      ...sessionExpiriesFromLoginSuccess(data),
      method
    };
    this.setSession(newSession);
  }
  /**
   * Trigger a silent OIDC re-auth flow that lands the user back at
   * `returnTo`. POSTs to the OIDC login dispatcher with the return URL
   * stashed server-side, then returns the auth URL the caller redirects
   * the browser to.
   */
  async initiateOidcRefresh(returnTo) {
    const { data } = await this.client.post("/login", {
      type: "OIDC" /* OIDC */,
      content: { return_to: returnTo }
    });
    if (data.type !== "OIDC" /* OIDC */) {
      throw new Error("AUTH: unexpected login challenge type from OIDC refresh");
    }
    return data.content.auth_url;
  }
  /**
   * Refresh the short-lived access token. Track 9 split-token: the browser
   * sends no body — the `__Secure-session` HttpOnly cookie (path `/v1/a/`)
   * is the only refresh credential. `withCredentials: true` is required so
   * the cookie travels.
   *
   * On 401/403, the session is cleared locally; the caller is expected to
   * navigate to /login. Transient failures (5xx, network) throw without
   * clearing — callers can back off and retry.
   */
  async refresh() {
    try {
      const { data } = await this.client.post(
        "/login/refresh",
        {},
        { withCredentials: true }
      );
      const method = this.session.method;
      if (!method) {
        console.warn("AUTH: refresh attempted with no session.method; clearing session");
        this.clearSession();
        throw new Error("AUTH: session has no method, refresh aborted");
      }
      const publicKey = method === "NOSTR" /* NOSTR */ ? this.session.publicKey : void 0;
      this.applyLoginSuccess(data, method, publicKey);
      console.info("AUTH: Token refresh successful");
      return data;
    } catch (error) {
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        console.warn(`AUTH: refresh rejected (${status}); clearing session`);
        this.clearSession();
        throw new Error("AUTH: Authentication failed, session cleared");
      }
      console.warn("AUTH: refresh failed transiently; session preserved", error);
      throw error;
    }
  }
  /**
   * GET /v1/a/whoami — fresh identity claims for the current session.
   * Backend caches OIDC responses in Redis for 5min so this is cheap.
   *
   * `withCredentials: true` is required because the endpoint reads the
   * session cookie (and the access token bearer). Updates the local
   * session opportunistically with the freshest email / displayName.
   */
  async whoami() {
    const headers = this.hasValidAccessToken() ? makeAuthHeaders(this.getAccessToken()) : void 0;
    const { data } = await this.client.get("/a/whoami", {
      withCredentials: true,
      headers
    });
    if (this.session.isLoggedIn) {
      this.setSession({
        ...this.session,
        email: data.email ?? this.session.email,
        displayName: data.display_name ?? this.session.displayName
      });
    }
    return data;
  }
  /**
   * Logout sequence (frontend #7 ordering):
   *   1. OIDC only: fetch end-session URL while the cookie + access token
   *      are still valid. Backend reads the id_token from the session row,
   *      so no `id_token_hint` query param.
   *   2. POST /v1/a/logout — backend deletes the row, revokes IdP refresh,
   *      clears the cookie via Set-Cookie Max-Age=0.
   *   3. Clear local session state.
   *   4. OIDC only: navigate to the end-session URL.
   */
  async logout() {
    const isOidc = this.session.method === "OIDC" /* OIDC */;
    const authHeaders = this.hasValidAccessToken() ? makeAuthHeaders(this.getAccessToken()) : void 0;
    let endSessionUrl = null;
    if (isOidc) {
      try {
        const { data } = await this.client.get("/a/auth/oidc/end-session-url", {
          withCredentials: true,
          headers: authHeaders
        });
        endSessionUrl = data.url;
      } catch (error) {
        console.error(
          "AUTH: failed to fetch OIDC end-session URL; proceeding with local logout.",
          error
        );
      }
    }
    try {
      await this.client.post(
        "/a/logout",
        {},
        { withCredentials: true, headers: authHeaders }
      );
    } catch (error) {
      console.error("AUTH: /a/logout failed; clearing session regardless", error);
    }
    this.clearSession();
    if (endSessionUrl) {
      if (isSafeRedirectTarget(endSessionUrl)) {
        window.location.assign(endSessionUrl);
      } else {
        console.error("AUTH: refusing unsafe end-session URL; falling back to local logout.", {
          endSessionUrl
        });
        window.location.assign("/");
      }
    }
  }
};

// src/deposit.ts
var RustyDeposit = class {
  constructor({ client }) {
    this.client = client;
  }
  async getAccountMovements(query, accessToken) {
    let url = `/a/movements`;
    if (query) {
      url += `?${new URLSearchParams(query)}`;
    }
    const result = await this.client.get(url, {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async getAccountBalance(accessToken) {
    const result = await this.client.get("/a/balance", {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async getDeposits(query, accessToken) {
    let url = `/a/deposits`;
    if (query) {
      url += `?${new URLSearchParams(query)}`;
    }
    const result = await this.client.get(url, {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async getDeposit(id, accessToken) {
    const result = await this.client.get(`/a/deposits/${id}`, {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async newDeposit(deposit, accessToken) {
    const result = await this.client.post("/a/deposits", deposit, {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
};

// src/oidc-handoff.ts
import axios2 from "axios";
async function fetchOidcHandoffConfig(apiBaseUrl) {
  const url = `${apiBaseUrl.replace(/\/$/, "")}/v1/auth/oidc/handoff-config`;
  try {
    const { data } = await axios2.get(url, {
      timeout: 5e3,
      // Public endpoint, keep it cacheable.
      withCredentials: false
    });
    return data;
  } catch (err) {
    if (axios2.isAxiosError(err) && err.response?.status === 404) {
      return null;
    }
    console.warn("[oidc] fetchOidcHandoffConfig failed:", err);
    return null;
  }
}
function buildIdpHandoffUrl({
  config,
  action,
  returnTo
}) {
  if (!config.handoff_actions_supported.includes(action)) {
    return null;
  }
  const params = new URLSearchParams({
    referrer: config.client_id,
    referrer_uri: returnTo,
    action
  });
  return `${config.handoff_endpoint}?${params.toString()}`;
}
function buildAccountManagementUrl(config) {
  return config.account_management_uri;
}

// src/referral.ts
var RustyReferral = class {
  constructor({ client }) {
    this.client = client;
  }
  async getReferralCode(accessToken) {
    const result = await this.client.get("/a/referrals/code", {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async getReferralStats(accessToken) {
    const result = await this.client.get("/a/referrals/stats", {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async getReferralHistory(accessToken) {
    const result = await this.client.get("/a/referrals/history", {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
};

// src/security-log.ts
var RustySecurityLog = class {
  constructor({ client }) {
    this.client = client;
  }
  async getSecurityLog(query, accessToken) {
    const params = {};
    if (query.page !== void 0) params.page = query.page;
    if (query.per_page !== void 0) params.per_page = query.per_page;
    const result = await this.client.get("/a/audit", {
      params,
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
};

// src/subscription.ts
var RustySubscription = class {
  constructor({ client }) {
    this.client = client;
  }
  async getSubscriptionPlans() {
    const result = await this.client.get("/subscriptions/plans");
    return result.data;
  }
  async getCurrentSubscription(accessToken) {
    try {
      const result = await this.client.get("/a/subscriptions/current", {
        headers: makeAuthHeaders(accessToken)
      });
      return result.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }
  async subscribeToplan(planId, accessToken) {
    const result = await this.client.post(
      `/a/subscriptions/${planId}`,
      {},
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
  async cancelSubscription(accessToken) {
    const result = await this.client.delete("/a/subscriptions", {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async getSubscriptionUsage(accessToken) {
    const result = await this.client.get("/a/subscriptions/usage", {
      headers: makeAuthHeaders(accessToken)
    });
    return result.data;
  }
  async createCustomerPortalSession(accessToken) {
    const result = await this.client.post(
      "/a/subscriptions/portal",
      {},
      { headers: makeAuthHeaders(accessToken) }
    );
    return result.data;
  }
};

// src/subscription-utils.ts
function isCurrentPlan(planId, currentSubscription) {
  return currentSubscription?.plan_id === planId && currentSubscription?.status?.toLowerCase() === "active";
}
function isNextPlan(planId, currentSubscription) {
  return currentSubscription?.next_plan_id === planId && currentSubscription?.next_plan_id !== currentSubscription?.plan_id;
}
function hasNextPlan(currentSubscription) {
  return Boolean(
    currentSubscription?.next_plan_id && currentSubscription.next_plan_id !== currentSubscription.plan_id
  );
}
function getNextPlan(currentSubscription, subscriptionPlans) {
  if (!currentSubscription?.next_plan_id || !subscriptionPlans) {
    return null;
  }
  return subscriptionPlans.find((p) => p.id === currentSubscription.next_plan_id) || null;
}
function getCurrentPlan(currentSubscription, subscriptionPlans) {
  if (!currentSubscription?.plan_id || !subscriptionPlans) {
    return null;
  }
  const planId = currentSubscription.plan_id || currentSubscription.plan_name;
  return subscriptionPlans.find((p) => p.id === planId || p.name === planId) || null;
}
function isPaidPlan(currentSubscription, subscriptionPlans) {
  if (!currentSubscription?.plan_id && !currentSubscription?.plan_name) {
    return false;
  }
  const plan = getCurrentPlan(currentSubscription, subscriptionPlans);
  return Boolean(plan && !plan.is_free_plan);
}
function getPlanDisplayName(currentSubscription) {
  return currentSubscription?.plan_name || currentSubscription?.plan_id || "Unknown Plan";
}
function getStatusColor(status) {
  const normalizedStatus = status.toLowerCase();
  switch (normalizedStatus) {
    case "active":
      return "green";
    case "canceled":
      return "red";
    case "past_due":
      return "orange";
    case "incomplete":
      return "yellow";
    default:
      return "gray";
  }
}

// src/verified-emails.ts
var RustyVerifiedEmails = class {
  constructor({ client }) {
    this.client = client;
  }
  async newVerifiedEmail(data, accessToken) {
    await this.client.post("/a/emails/verify", data, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
  }
  async verifyVerifiedEmail(id, accessToken) {
    await this.client.post(
      "/a/emails/verify/retry",
      { verified_email_id: id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
  }
  async deleteVerifiedEmail(id, accessToken) {
    await this.client.delete(`/a/emails/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
  }
  async setAccountEmail(id, accessToken) {
    await this.client.put(
      `/a/emails/${id}/set-account-email`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
  }
  async getVerifiedEmails(accessToken) {
    const response = await this.client.get("/a/emails", {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    return response.data;
  }
};
export {
  Currency,
  DepositProvider,
  DepositStatus,
  LOGIN_METHOD,
  LOGIN_METHOD_EMAIL_MAGIC_LINK,
  LOGIN_METHOD_GITHUB,
  LOGIN_METHOD_GOOGLE,
  LOGIN_METHOD_MICROSOFT,
  LOGIN_METHOD_NOSTR,
  LOGIN_METHOD_OIDC,
  OFFICIAL_LOGIN_METHODS,
  RustyApiKeys,
  RustyAuth,
  RustyDeposit,
  RustyReferral,
  RustySecurityLog,
  RustySubscription,
  RustyVerifiedEmails,
  SubscriptionStatus,
  TwoFactorMethodType,
  axiosFieldValidationErrorToFormErrors,
  balanceNextHigher,
  buildAccountManagementUrl,
  buildIdpHandoffUrl,
  clearLsSession,
  decodeNostrPrivateKey,
  decodeNostrPublicKey,
  deepMerge,
  fetchOidcHandoffConfig,
  formatCurrency,
  getCurrentPlan,
  getErrorTitle,
  getLsLoginSession,
  getLsSession,
  getNextPlan,
  getPlanDisplayName,
  getStatusColor,
  hasFieldValidationError,
  hasFutureExpiry,
  hasNextPlan,
  isCurrentPlan,
  isNextPlan,
  isOfficialLoginMethod,
  isPaidPlan,
  isSafeRedirectTarget,
  isSafeSameOriginTarget,
  loginMethodFromType,
  loginMethodFromTypeOrThrow,
  makeAuthHeaders,
  makeUrl,
  parseRSS,
  sessionExpiriesFromLoginSuccess,
  setLsSession
};
//# sourceMappingURL=index.js.map